import 'src/features/campaign-emails/endpoints/campaign-email.endpoints';
import { CampaignEmailsTab } from 'src/features/campaign-emails/campaign-emails-tab';

export default function CampaignEmailsManageTab() {
  return <CampaignEmailsTab />;
}
